import { createVanIconComponent } from "./van"

const BalancePay = createVanIconComponent("balance-pay")
export default BalancePay
